import axios from 'axios';

export default {
    pre_insercion(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_compp_corredores.pre_insercion",
				"p_args_in": JSON.stringify({
                    "p_usuario": p_usuario,
				  })
			})
	},

	consulta_poliza(p_email, p_ejecutivo, p_poliza){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_BaseDatos.fnc_consultaPoliza",
			"p_args_in": JSON.stringify({
				"p_ejecutivo": p_ejecutivo,
				"p_poliza": p_poliza,
			  })
		})
	},

	consulta_contratante(p_email, p_contratante){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_BaseDatos.fnc_consultacontratante",
			"p_args_in": JSON.stringify({
				"p_contratante": p_contratante,
				})
		})
	},
	consulta_corredor(p_email, p_corredor){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_corredores.fnc_consultaCorredor",
			"p_args_in": JSON.stringify({
				"p_codcorredor": p_corredor,
				})
		})
	},
	consulta_contactos(p_email, p_ejecutivo, p_poliza, p_contratante, p_corredor){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_BaseDatos.fnc_ConsultaContactos",
			"p_args_in": JSON.stringify({
				"p_ejecutivo": p_ejecutivo,
				"p_poliza": p_poliza,
				"p_contratante": p_contratante,
				"p_corredor": p_corredor,
				})
		})
	},
	
	eliminar(p_email, p_usuario,p_gicidinfcorr){
        return axios
        .post('spoc/modppentry', {
            "p_email": p_email,
            "p_metodo": "pkg_compp_corredores.eliminar",
            "p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_gicidinfcorr": p_gicidinfcorr
                })
        })
    },
	insertar(p_email, p_usuario, p_giccodcorredor, p_gicnomcontacto, p_gicapellcontacto, p_giccargo,
			p_gicmail, p_gictelefonofijo, p_gictelefonomovil, p_giccontactocomcred,
			p_giccontactoventas, p_giccontactosiniestro, p_giccontactogarantia, 
			p_giccontactorecuperos, p_gicdireccionparticular, p_gicciudad, p_giccomuna,
			p_gicfechacumpleanos, p_giccategoriacontacto, p_gicestado, p_gicobservacion,
			p_gicultimamodificacion, p_gicusuario){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_corredores.insertar",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_giccodcorredor": p_giccodcorredor,
				"p_gicnomcontacto": p_gicnomcontacto,
				"p_gicapellcontacto": p_gicapellcontacto,
				"p_giccargo": p_giccargo,
				"p_gicmail": p_gicmail,
				"p_gictelefonofijo": p_gictelefonofijo,
				"p_gictelefonomovil": p_gictelefonomovil,
				"p_giccontactocomcred": p_giccontactocomcred,
				"p_giccontactoventas": p_giccontactoventas,
				"p_giccontactosiniestro": p_giccontactosiniestro,
				"p_giccontactogarantia": p_giccontactogarantia,
				"p_giccontactorecuperos": p_giccontactorecuperos,
				"p_gicdireccionparticular": p_gicdireccionparticular,
				"p_gicciudad": p_gicciudad,
				"p_giccomuna": p_giccomuna,
				"p_gicfechacumpleanos": p_gicfechacumpleanos,
				"p_giccategoriacontacto": p_giccategoriacontacto,
				"p_gicestado": p_gicestado,
				"p_gicobservacion": p_gicobservacion,
				"p_gicultimamodificacion": p_gicultimamodificacion,
				"p_gicusuario": p_gicusuario
				})
		})
	},
	editar(p_email, p_usuario, p_gicidinfcorr, p_gicnomcontacto, p_gicapellcontacto, p_giccargo,
		   p_gicmail, p_gictelefonofijo, p_gictelefonomovil, p_giccontactocomcred,
		   p_giccontactoventas, p_giccontactosiniestro, p_giccontactogarantia, 
		   p_giccontactorecuperos, p_gicdireccionparticular, p_gicciudad, p_giccomuna,
		   p_gicfechacumpleanos, p_giccategoriacontacto, p_gicestado, p_gicobservacion,
		   p_gicultimamodificacion,	p_gicusuario){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_corredores.Editar",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_gicidinfcorr": p_gicidinfcorr,
				"p_gicnomcontacto": p_gicnomcontacto,
				"p_gicapellcontacto": p_gicapellcontacto,
				"p_giccargo": p_giccargo,
				"p_gicmail": p_gicmail,
				"p_gictelefonofijo": p_gictelefonofijo,
				"p_gictelefonomovil": p_gictelefonomovil,
				"p_giccontactocomcred": p_giccontactocomcred,
				"p_giccontactoventas": p_giccontactoventas,
				"p_giccontactosiniestro": p_giccontactosiniestro,
				"p_giccontactogarantia": p_giccontactogarantia,
				"p_giccontactorecuperos": p_giccontactorecuperos,
				"p_gicdireccionparticular": p_gicdireccionparticular,
				"p_gicciudad": p_gicciudad,
				"p_giccomuna": p_giccomuna,
				"p_gicfechacumpleanos": p_gicfechacumpleanos,
				"p_giccategoriacontacto": p_giccategoriacontacto,
				"p_gicestado": p_gicestado,
				"p_gicobservacion": p_gicobservacion,
				"p_gicultimamodificacion": p_gicultimamodificacion,
				"p_gicusuario": p_gicusuario
				})
		});
	},
	recuperar(p_email, p_corredor, p_cargo, p_estado){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_corredores.recuperar",
			"p_args_in": JSON.stringify({
				"p_corredor": p_corredor,
				"p_cargo": p_cargo,
				"p_estado": p_estado
				})
		})
	},

    verificarDatosContacto(p_mail, p_id, p_nombre, p_apellido, p_correo){
        return axios.post('spoc/modppentry', {
                "p_email": p_mail,
                "p_metodo": "pkg_compp_corredores.verificar_datos_contacto",
                "p_args_in": JSON.stringify({
			    "p_id": p_id,		
                "p_nombre": p_nombre,
                "p_apellido": p_apellido,
                "p_correo"  : p_correo
            })
        })
    },
}